import { calendarEventConstants } from "../../_constants";
import axiosInstance from "../../../_helpers/axiosInstance";
import config from "../../../_config/config";
import { showWarningMessage } from "../../../_uiComponents/ShowMessageSnack";

// create interview
export const create_calendar_event_action = (data) => async (dispatch) => {
  dispatch({
    type: calendarEventConstants.CREATE_CALENDAR_EVENT_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.post(
      config.common.calendarEvent,
      data
    );
    if (response.status) {
      dispatch({
        type: calendarEventConstants.CREATE_CALENDAR_EVENT_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: calendarEventConstants.CREATE_CALENDAR_EVENT_ACTION_FAILURE,
      payload: e.msg,
    });
    showWarningMessage(e?.msg);

    return e;
  }
};

// update interview
export const update_calendar_event_action = (data, id) => async (dispatch) => {
  dispatch({
    type: calendarEventConstants.UPDATE_CALENDAR_EVENT_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.put(
      config.common.calendarEventById.replace(":id", id),
      data
    );
    if (response.status) {
      dispatch({
        type: calendarEventConstants.UPDATE_CALENDAR_EVENT_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: calendarEventConstants.UPDATE_CALENDAR_EVENT_ACTION_FAILURE,
      payload: e.msg,
    });
    showWarningMessage(e?.msg);

    return e;
  }
};

//delete event
export const delete_calendar_event_action = (id) => async (dispatch) => {
  dispatch({
    type: calendarEventConstants.DELETE_CALENDAR_EVENT_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.delete(
      config.common.calendarEventById.replace(":id", id)
    );
    if (response.status) {
      dispatch({
        type: calendarEventConstants.DELETE_CALENDAR_EVENT_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: calendarEventConstants.DELETE_CALENDAR_EVENT_ACTION_FAILURE,
      payload: e.msg,
    });
    showWarningMessage(e?.msg);

    return e;
  }
};

//get event details
export const get_calendar_event_details_action = (id) => async (dispatch) => {
  dispatch({
    type: calendarEventConstants.GET_CALENDAR_EVENT_DETAILS_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.get(
      config.common.calendarEventById.replace(":id", id)
    );
    if (response.status) {
      dispatch({
        type: calendarEventConstants.GET_CALENDAR_EVENT_DETAILS_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: calendarEventConstants.GET_CALENDAR_EVENT_DETAILS_ACTION_FAILURE,
      payload: e.msg,
    });
    showWarningMessage(e?.msg);

    return e;
  }
};

//get event details
export const create_calendar_event_availability_action =
  (data) => async (dispatch) => {
    dispatch({
      type: calendarEventConstants.CREATE_CALENDAR_EVENT_AVAILABILITY_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.post(
        config.common.calendarEventAvailability,
        data
      );
      if (response.status) {
        dispatch({
          type: calendarEventConstants.CREATE_CALENDAR_EVENT_AVAILABILITY_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: calendarEventConstants.CREATE_CALENDAR_EVENT_AVAILABILITY_ACTION_FAILURE,
        payload: e.msg,
      });
      return e;
    }
  };

//get event details
export const update_calendar_event_availability_action =
  (id, data) => async (dispatch) => {
    dispatch({
      type: calendarEventConstants.UPDATE_CALENDAR_EVENT_AVAILABILITY_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.put(
        config.common.calendarEventAvailabilityById.replace(":id", id),
        data
      );
      if (response.status) {
        dispatch({
          type: calendarEventConstants.UPDATE_CALENDAR_EVENT_AVAILABILITY_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: calendarEventConstants.UPDATE_CALENDAR_EVENT_AVAILABILITY_ACTION_FAILURE,
        payload: e.msg,
      });
      return e;
    }
  };

//get event details
export const get_calendar_event_availability_action =
  (id, data) => async (dispatch) => {
    dispatch({
      type: calendarEventConstants.GET_CALENDAR_EVENT_AVAILABILITY_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.get(
        config.common.calendarEventAvailabilityById.replace(":id", id)
      );
      if (response.status) {
        dispatch({
          type: calendarEventConstants.GET_CALENDAR_EVENT_AVAILABILITY_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: calendarEventConstants.GET_CALENDAR_EVENT_AVAILABILITY_ACTION_FAILURE,
        payload: e.msg,
      });
      return e;
    }
  };

//get event lists
export const get_calendar_event_lists_action = (page) => async (dispatch) => {
  dispatch({
    type: calendarEventConstants.GET_CALENDAR_EVENT_LISTS_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.get(
      `${config.common.calendarEventLists}?page=${page ? page : 1}`
    );
    if (response.status) {
      dispatch({
        type: calendarEventConstants.GET_CALENDAR_EVENT_LISTS_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: calendarEventConstants.GET_CALENDAR_EVENT_LISTS_ACTION_FAILURE,
      payload: e.msg,
    });
    showWarningMessage(e?.msg);

    return e;
  }
};

//get event lists
export const get_calendar_scheduled_event_lists_action =
  () => async (dispatch) => {
    dispatch({
      type: calendarEventConstants.GET_CALENDAR_SCHEDULED_EVENT_LISTS_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.get(
        config.common.scheduledInterviewList
      );
      if (response.status) {
        dispatch({
          type: calendarEventConstants.GET_CALENDAR_SCHEDULED_EVENT_LISTS_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: calendarEventConstants.GET_CALENDAR_SCHEDULED_EVENT_LISTS_ACTION_FAILURE,
        payload: e.msg,
      });
      return e;
    }
  };

//scheduled interviews
export const get_calendar_upcoming_scheduled_event_lists_action =
  (page) => async (dispatch) => {
    dispatch({
      type: calendarEventConstants.GET_CALENDAR_UPCOMING_SCHEDULED_EVENT_LISTS_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.get(
        `${config.common.upcomingScheduledInterviews}?page=${page ? page : 1}`
      );
      if (response.status) {
        dispatch({
          type: calendarEventConstants.GET_CALENDAR_UPCOMING_SCHEDULED_EVENT_LISTS_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: calendarEventConstants.GET_CALENDAR_UPCOMING_SCHEDULED_EVENT_LISTS_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  };

//scheduled interviews
export const get_calendar_past_scheduled_event_lists_action =
  (page) => async (dispatch) => {
    dispatch({
      type: calendarEventConstants.GET_CALENDAR_PAST_SCHEDULED_EVENT_LISTS_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.get(
        `${config.common.pastScheduledInterviews}?page=${page ? page : 1}`
      );
      if (response.status) {
        dispatch({
          type: calendarEventConstants.GET_CALENDAR_PAST_SCHEDULED_EVENT_LISTS_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: calendarEventConstants.GET_CALENDAR_PAST_SCHEDULED_EVENT_LISTS_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  };

//get event lists
export const get_calendar_unregistered_user_scheduled_event_lists_action =
  () => async (dispatch) => {
    dispatch({
      type: calendarEventConstants.GET_CALENDAR_UNREGISTERED_USER_SCHEDULED_EVENT_LISTS_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.get(
        config.common.unregisteredUserScheduledInterviewList
      );
      if (response.status) {
        dispatch({
          type: calendarEventConstants.GET_CALENDAR_UNREGISTERED_USER_SCHEDULED_EVENT_LISTS_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: calendarEventConstants.GET_CALENDAR_UNREGISTERED_USER_SCHEDULED_EVENT_LISTS_ACTION_FAILURE,
        payload: e.msg,
      });
      return e;
    }
  };

//get event details
export const get_calendar_event_link_action = (id) => async (dispatch) => {
  dispatch({
    type: calendarEventConstants.GET_CALENDAR_EVENT_LINK_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.get(
      config.common.getCalendarEventLink.replace(":id", id)
    );
    if (response.status) {
      dispatch({
        type: calendarEventConstants.GET_CALENDAR_EVENT_LINK_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: calendarEventConstants.GET_CALENDAR_EVENT_LINK_ACTION_FAILURE,
      payload: e.msg,
    });
    showWarningMessage(e?.msg);

    return e;
  }
};

//get event details
export const assign_calendar_event_link_to_candidate_action =
  (data) => async (dispatch) => {
    dispatch({
      type: calendarEventConstants.ASSIGN_CALENDAR_EVENT_LINK_TO_CANDIDATE_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.post(
        config.common.assignEventLinkToCandidate,
        data
      );
      if (response.status) {
        dispatch({
          type: calendarEventConstants.ASSIGN_CALENDAR_EVENT_LINK_TO_CANDIDATE_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: calendarEventConstants.ASSIGN_CALENDAR_EVENT_LINK_TO_CANDIDATE_ACTION_FAILURE,
        payload: e.msg,
      });
      return e;
    }
  };
